// frontend/src/store/slices/preferencesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchPreferences = createAsyncThunk(
  'preferences/fetchPreferences',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/preferences/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const savePreferences = createAsyncThunk(
  'preferences/savePreferences',
  async ({ userId, preferences }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/preferences/${userId}`, preferences);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreferences.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPreferences.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPreferences.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(savePreferences.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(savePreferences.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(savePreferences.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default preferencesSlice.reducer;